import { Link } from "react-router-dom";

import { Button } from "@/components/button";

export function NotFound() {
  return (
    <div className="container mx-auto px-4 py-16 flex items-center justify-center min-h-[60vh]">
      <div className="bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 max-w-md w-full">
        <div className="text-center px-6">
          <div className="text-6xl font-bold text-muted-foreground">404</div>
        </div>
        <div className="text-center space-y-4 px-6">
          <h1 className="text-2xl font-semibold">Page Not Found</h1>
          <p className="text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="pt-4">
            <Button asChild>
              <Link to="/">Return to Home</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
